<script setup lang="ts"></script>

<template>
  <footer class="w-full flex-[0_0_auto]">
    <div class="main-container flex w-full flex-col gap-4 py-6">
      <div class="flex w-full items-center justify-between gap-2">
        <div class="flex flex-wrap gap-x-4 gap-y-2">
          <NuxtLink
            class="inline-flex items-center justify-center gap-2 text-xs font-medium text-on-primary-body underline decoration-transparent underline-offset-6 transition duration-150 hover:decoration-on-primary-heading md:text-sm"
            to="/privacy-policy"
          >
            Privacy Policy
          </NuxtLink>
          <NuxtLink
            class="inline-flex items-center justify-center gap-2 text-xs font-medium text-on-primary-body underline decoration-transparent underline-offset-6 transition duration-150 hover:decoration-on-primary-heading md:text-sm"
            to="/terms"
          >
            Terms of use
          </NuxtLink>
          <NuxtLink
            class="inline-flex items-center justify-center gap-2 text-xs font-medium text-on-primary-body underline decoration-transparent underline-offset-6 transition duration-150 hover:decoration-on-primary-heading md:text-sm"
            to="/cancellation-policy"
          >
            Cancellation Policy
          </NuxtLink>
          <NuxtLink
            class="inline-flex items-center justify-center gap-2 text-xs font-medium text-on-primary-body underline decoration-transparent underline-offset-6 transition duration-150 hover:decoration-on-primary-heading md:text-sm"
            to="/shipping-policy"
          >
            Shipping Policy
          </NuxtLink>
          <NuxtLink
            class="inline-flex items-center justify-center gap-2 text-xs font-medium text-on-primary-body underline decoration-transparent underline-offset-6 transition duration-150 hover:decoration-on-primary-heading md:text-sm"
            to="/contact-us"
          >
            Contact Us
          </NuxtLink>
        </div>
        <div class="flex items-center gap-4">
          <NuxtLink
            class="flex items-center justify-center"
            to="mailto:connect@quietart.com"
            aria-label="Email Quiet Art Movement"
          >
            <Icon class="text-xl" name="lucide:mail" />
          </NuxtLink>
          <NuxtLink
            class="flex items-center justify-center"
            to="https://www.instagram.com/quietartmovement"
            aria-label="Visit our Instagram page"
          >
            <Icon class="text-xl" name="iconoir:instagram" />
          </NuxtLink>
        </div>
      </div>
      <div
        class="mt-2 text-center text-xs text-on-primary-body opacity-95 md:text-sm"
      >
        Copyright ©️ 2026 Quiet Art Movement Private Limited. All Rights
        Reserved.
      </div>
    </div>
  </footer>
</template>
